/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
/** パートナー、子どもの存在を表すルールに使う */
export type AttackListSenderSettingRuleExistence =
  /** 存在する */
  | 'EXIST'
  /** 存在しない */
  | 'NOT_EXIST'
  /** 指定しない(存在してもしなくてもいい) */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleGender =
  | 'FEMALE'
  | 'MALE'
  /** 性別は指定しない */
  | 'NOT_SPECIFIED';

export type SettingsPageAttackListSenderViewSettingItemAttackListSenderSettingFragment = { id: string, isEnabled: boolean, title: string, body: string, selections: Array<string>, entrance: { guid: string, name: string }, planner: { id: string, name: string }, rule: { partner: Types.AttackListSenderSettingRuleExistence, child: Types.AttackListSenderSettingRuleExistence, gender: Types.AttackListSenderSettingRuleGender, shouldSendIfSameCorporationApproached: boolean, savingRange: { min: number | null, max: number | null } | null, annualIncomeRange: { min: number | null, max: number | null } | null, familyAnnualIncomeRange: { min: number | null, max: number | null } | null, ageOfFirstChildRange: { min: number | null, max: number | null } | null, age: { min: number | null, max: number | null } | null, investmentRange: { min: number | null, max: number | null } | null } };

export const SettingsPageAttackListSenderViewSettingItemAttackListSenderSettingFragmentDoc = gql`
    fragment SettingsPageAttackListSenderViewSettingItemAttackListSenderSetting on AttackListSenderSetting {
  id
  entrance {
    guid
    name
  }
  planner {
    id
    name
  }
  isEnabled
  title
  body
  selections
  rule {
    savingRange {
      min
      max
    }
    annualIncomeRange {
      min
      max
    }
    familyAnnualIncomeRange {
      min
      max
    }
    partner
    child
    ageOfFirstChildRange {
      min
      max
    }
    gender
    age {
      min
      max
    }
    investmentRange {
      min
      max
    }
    shouldSendIfSameCorporationApproached
  }
}
    `;